var map = {
	"./home": 14,
	"./home.js": 14,
	"./software/based/based_banner.png": 31,
	"./software/cartridges/cartridges_banner.png": 32,
	"./software/meerkat/meerkat_banner_small.png": 33,
	"./software/minions/minions_banner_small.png": 34,
	"./software/tokasaurus/toka-banner.png": 35,
	"./software/zoology/zoology_banner.png": 36,
	"./software/zoology/zoology_banner_small.png": 37
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30;